import Core from '../../../Core/Core';
import { HudActions, HudEmitter } from '../../../Managers/Hud/HudEmitter';
import { Popup } from '../../../Managers/Popups';
import { createPixiText, scaleToFit } from '../../../Utils/Utils';
import { ButtonColors } from '../../Shared/Buttons/NineSliceButton';
import { TextButton } from '../../Shared/Buttons/TextButton';
import { EmbeddedSprite } from '../../Shared/EmbeddedSprite';
import { CharacterPopup } from '../CharacterPopup';

export class CrossPromoPopup extends CharacterPopup {
    constructor(
        width: number,
        height: number,
        banner: EmbeddedSprite,
        gameId: number,
        gameName: string
    ) {
        super(width, height, 'character/character-goal', 'ANewGame', Popup.XPROMO);
        const { header, bg } = this;
        header.y += 50;
        bg.y += 50;
        const text = createPixiText(
            Core.local.getText('FunGame'),
            new PIXI.Rectangle(width / 2, 0, width * 0.95, height * 0.05),
            'Baloo',
            35,
            30,
            0xd53700
        );

        const gameBanner = banner;
        gameBanner.scale.set(
            scaleToFit(gameBanner.width, gameBanner.height, width * 0.8, height * 0.5)
        );
        gameBanner.anchor.set(0.5);
        gameBanner.x = width / 2;

        text.y = header.y + header.height * 0.45 + text.height * 0.5 + 12.5;
        gameBanner.y = text.y + text.height * 0.5 + gameBanner.height * 0.5 + 12.5;

        const playButton = new TextButton({
            width: width * 0.5,
            height: height * 0.15,
            btnText: Core.local.getText('play'),
            color: ButtonColors.GREEN,
            outline: 0x3e6c69,
        });
        playButton.on('trigger', () => {
            HudEmitter.instance.emit(HudActions.SWITCH_GAME, gameId.toString(), gameName, 'map');
        });
        //@ts-ignore
        this.addChild(header, gameBanner, text, playButton);

        playButton.x = width / 2;
        playButton.y = gameBanner.y + gameBanner.height * 0.5 + playButton.height * 0.5 + 25;

        const newHeight = playButton.y + playButton.height / 2;

        bg.height = newHeight;
    }
}
